/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useReducer } from "react";
import { Sidebar } from "~/components";
import {
  ResourceDetailsActionDetailsSidebarFilterType,
  ResourceDetailsActionDetailsSidebarState,
} from "../../../types/ResourceDetailsActionDetailsSidebarState";
import { ResourceDetailsActionDetailsSidebarHeader } from "./ResourceDetailsActionDetailsSidebarHeader";
import { ResourceDetailsActionDetailsSidebarCtxProvider } from "./ResourceDetailsActionDetailsSidebarProvider";
import { ResourceDetailsActionDetailsSidebarTable } from "./ResourceDetailsActionDetailsSidebarTable";

type Props = {
  isOpen: boolean;
  close: () => void;
  resourceId: string;
  eventId: string;
  eventActionId: string;
  actionName: string;
};

export function ResourceDetailsActionDetailsSidebar({
  isOpen,
  close,
  actionName,
  eventId,
  eventActionId,
  resourceId,
}: Props) {
  const [actionDetailsState, updateActionDetailsState] = useReducer(
    (
      data: ResourceDetailsActionDetailsSidebarState,
      partialData: Partial<ResourceDetailsActionDetailsSidebarState>
    ) => ({
      ...data,
      ...partialData,
    }),
    {
      resources: undefined,
      filterQuery: ResourceDetailsActionDetailsSidebarFilterType.ALL,
    }
  );

  return (
    <Sidebar width="50vw" title={actionName} isOpen={isOpen} onClick={close}>
      <ResourceDetailsActionDetailsSidebarCtxProvider
        value={{ actionDetailsState, updateActionDetailsState }}
      >
        <ResourceDetailsActionDetailsSidebarHeader
          eventId={eventId}
          eventActionId={eventActionId}
          resourceId={resourceId}
        />
        <ResourceDetailsActionDetailsSidebarTable
          eventId={eventId}
          eventActionId={eventActionId}
          resourceId={resourceId}
        />
      </ResourceDetailsActionDetailsSidebarCtxProvider>
    </Sidebar>
  );
}
